var _defs, _path, _path2, _line, _line2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Regular",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chess-figures") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.75,18h5.479a1.5,1.5,0,0,1,1.48,1.253l.521,1.5A1.5,1.5,0,0,1,21.75,22.5H16.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.812,18V16.9A9.159,9.159,0,0,1,6.25,9.75H2.208A1.459,1.459,0,0,1,1.177,7.26l3.7-3.7V1.5l.364.081A7.429,7.429,0,0,1,11.055,8.84v.91c-3.437,3.438.69,8.27.69,8.27"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.092,
    y1: 9.241,
    x2: 14.045,
    y2: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.25,
    y1: 18,
    x2: 18.658,
    y2: 9.243
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.875,
    cy: 6.375,
    r: 3.375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.423,20.526l-.5-1.5A1.5,1.5,0,0,0,11.5,18H2.75a1.5,1.5,0,0,0-1.423,1.026l-.5,1.5A1.5,1.5,0,0,0,2.25,22.5H12a1.5,1.5,0,0,0,1.423-1.974Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicIcon);
export default __webpack_public_path__ + "static/media/Strategic_Icon.381a6434ffc471ea97dd70b143d6c1a7.svg";
export { ForwardRef as ReactComponent };